import { render } from "./LNavComponentTest.vue?vue&type=template&id=818969f8&scoped=true"
import script from "./LNavComponentTest.vue?vue&type=script&lang=js"
export * from "./LNavComponentTest.vue?vue&type=script&lang=js"

import "./LNavComponentTest.vue?vue&type=style&index=0&id=818969f8&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-818969f8"]])

export default __exports__